import { render, staticRenderFns } from "./MessageDropDown.vue?vue&type=template&id=633f6fba"
import script from "./MessageDropDown.vue?vue&type=script&lang=js"
export * from "./MessageDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports